import React, { useState, useMemo } from 'react'
import { mediaType } from 'src/lib/types/AppStoreTypes'
import { classNames } from 'src/lib/utils/helpers'

type MediaCollageProps = {
  medias: mediaType[]
}

const MediaCollage: React.FC<MediaCollageProps> = ({ medias }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const activeMedia = useMemo(() => {
    return medias.find(media => !media.tags?.includes('BANNER_VIDEO')) ?? medias[0]
  }, [medias?.length])

  const handleMediaClick = (media: mediaType) => {
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      <div className='flex flex-col items-start justify-center space-y-6 aspect-video w-full'>
        {/* Primary media */}
        {activeMedia && (
          <div className={classNames('flex flex-col items-center justify-center flex-1 w-full')}>
            <div className='cursor-pointer relative h-full w-full' onClick={() => handleMediaClick(activeMedia)}>
              <div
                className={`absolute top-0 left-0 w-full h-full bg-transparent ${isModalOpen ? '' : 'z-20'}`}
                onClick={() => handleMediaClick(activeMedia)}
              />
              {activeMedia.type === 'VIDEO' ? (
                <iframe
                  src={activeMedia.url}
                  title='YouTube video player'
                  allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                  allowFullScreen
                  className='rounded-lg -z-10 h-full w-full'
                ></iframe>
              ) : (
                <img src={activeMedia.url} alt={activeMedia.altText} className={`w-full h-full rounded-lg`} />
              )}
            </div>
          </div>
        )}

        {/* Other medias */}
        {/* <div className='flex w-full flex-wrap justify-between'>
          {sortedMedias.map((media, index) => (
            <div
              key={index}
              className='cursor-pointer w-28 h-28 overflow-hidden border border-gray-200 rounded-lg'
              onClick={() => setActiveMedia(media)} 
            >
              {media.type === 'VIDEO' ? (
                <video
                  width='100%'
                  height='100%'
                  muted
                  src={media.url}
                  className='w-full h-full object-cover'
                />
              ) : (
                <img
                  src={media.url}
                  alt={media.altText}
                  className='w-full h-full object-cover'
                />
              )}
            </div>
          ))}
        </div> */}
      </div>

      {isModalOpen && activeMedia && (
        <div className='fixed inset-0 bg-black/70 flex justify-center items-center z-25' onClick={closeModal}>
          <div className='rounded-lg max-w-3xl max-h-[80%] overflow-hidden'>
            {activeMedia.type === 'VIDEO' ? (
              <iframe
                width={activeMedia.width ?? '680'}
                height={activeMedia.height ?? '400'}
                src={activeMedia.url}
                title='YouTube video player'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                allowFullScreen
                className='rounded-lg'
              ></iframe>
            ) : (
              <img src={activeMedia.url} alt={activeMedia.altText} className='w-full rounded-lg object-cover' />
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default MediaCollage
